import { render } from "./EmployeeLevelConfigAdd.vue?vue&type=template&id=3ec5d6c3"
import script from "./EmployeeLevelConfigAdd.vue?vue&type=script&lang=js"
export * from "./EmployeeLevelConfigAdd.vue?vue&type=script&lang=js"

import "./EmployeeLevelConfigAdd.vue?vue&type=style&index=0&id=3ec5d6c3&lang=less"

import exportComponent from "/Users/tinypocket/workspace/joysun/repositories/joysun-ems/joysun-ems-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__